import { forwardRef, type Ref, type SVGProps } from "react";
const IconCameraGridOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27 2H5a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 3v5.68h-6.67V4H27a1 1 0 0 1 1 1M12.67 19.33v-6.66h6.66v6.66Zm6.66 2V28h-6.66v-6.67Zm-8.66-2H4v-6.66h6.67Zm2-8.66V4h6.66v6.67Zm8.66 2H28v6.66h-6.67ZM5 4h5.68v6.67H4V5a1 1 0 0 1 1-1M4 27v-5.67h6.67V28H5a1 1 0 0 1-1-1m23 1h-5.67v-6.67H28V27a1 1 0 0 1-1 1"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCameraGridOutlineSVG);
ForwardRef.displayName = "IconCameraGridOutline";
export { ForwardRef as IconCameraGridOutline };
